export default __webpack_public_path__ + "f2adc17394cc57d9ffe1830257241de6.png";